import { PayloadAction } from '@reduxjs/toolkit';
import { createSlice } from 'utils/@reduxjs/toolkit';
import { useInjectReducer } from 'utils/redux-injectors';
import { Loft, LoftControlState } from './types';
import { gameManagerActions } from 'app/components/GameManager/slice';
import { selectLoftControlReport } from './selectors';
import {
  GameManagerState,
  AvailableCollectors,
} from 'app/components/GameManager/slice/types';

export const initialState: LoftControlState = {
  target: 0,
};

const slice = createSlice({
  name: 'loftControl',
  initialState,
  extraReducers: builder => {
    builder
      .addCase(
        gameManagerActions.restoreGame,
        (
          state,
          action: PayloadAction<{
            state: GameManagerState;
            lastDelivery: AvailableCollectors;
          }>,
        ) => {
          if (action.payload.lastDelivery.loft) {
            state.target = action.payload.lastDelivery.loft.target as any;
          }
        },
      )
      .addCase(
        gameManagerActions.newFrame,
        (state, action: PayloadAction<any>) => {
          state.execution = state.target;
        },
      )
      .addCase(
        gameManagerActions.beginEditDelivery,
        (state, action: PayloadAction<any>) => {
          state.save = state.execution;
        },
      )
      .addCase(
        gameManagerActions.setEditDelivery,
        (
          state,
          action: PayloadAction<{
            loft?: ReturnType<typeof selectLoftControlReport>;
          }>,
        ) => {
          state.execution = action.payload.loft?.execution;
        },
      )
      .addCase(
        gameManagerActions.finishEditDelivery,
        (state, action: PayloadAction<any>) => {
          state.execution = state.save;
        },
      );
  },
  reducers: {
    setTarget(state, action: PayloadAction<number>) {
      state.target = action.payload as Loft;
    },
    setExecution(state, action: PayloadAction<number>) {
      state.execution = action.payload as Loft;
    },
  },
});

export const { actions: speedControlActions } = slice;

export const useLoftControlSlice = () => {
  useInjectReducer({ key: slice.name, reducer: slice.reducer });
  return { actions: slice.actions };
};

/**
 * Example Usage:
 *
 * export function MyComponentNeedingThisSlice() {
 *  const { actions } = useSpeedControlSlice();
 *
 *  const onButtonClick = (evt) => {
 *    dispatch(actions.someAction());
 *   };
 * }
 */
